(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-toolbar"] && !Shopify.designMode) return;
  try {
    
  class CollectionSort extends HTMLElement {
    constructor() {
      super();
      this.querySelector('select').addEventListener('change', this.onSortChange.bind(this));
    }

    onSortChange(event) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.href = url.toString();
    }
  }

  customElements.define('collection-sort', CollectionSort);

  } catch(e) { console.error(e); }
})();
})();
